import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: '5px',
      marginLeft: '40px',
      cursor: 'pointer',
    },
  })
);

export function GridLeftPanelLoadMore({
  fetchMore,
}: {
  fetchMore: () => void;
}) {
  const { root } = useStyles();

  return (
    <Typography onClick={fetchMore} color="primary" className={root}>
      Načíst další
    </Typography>
  );
}
